module.exports = __webpack_public_path__ + "img/1952.e92592cd.gif";